import React,{ useState, useEffect } from 'react';
import { ManagerContext } from '../../contexts/ManagerContext';
import Container121 from '../container121';
import CustomDrawer from '../CustomDrawer';
import AvatarChat from '../AvatarStatic/AvatarChat';
import { Avatar, Typography, Stack, Grid2 as Grid, Card, Box, Button, IconButton, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import Paper from '@mui/material/Paper';
import { styled, useTheme } from '@mui/material/styles';
import RelationsInfo from './RelationsInfo';
import Post from './Post';

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: '#fff',
    height:'100%',
    // width: '100%', 
     // minHeight: '660px',
    borderRadius: '10px',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    ...theme.applyStyles('dark', {
      backgroundColor: '#5c5c5cc7',
    }),
  }));



export default function Profil( { owner=false, user }) {
    const { currentUser } = React.useContext(ManagerContext);
    useEffect( () => {
        var myDiv = document.getElementById('containerDiv');
        // myDiv.innerHTML = variableLongText;
        myDiv.scrollTop = 0;
    }, []);

    return (
        <div id='containerDiv' style={{ width: '100%', height: '100%', overflow: 'auto', alignSelf: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                
                {/* Zawartość z możliwością przewijania */}
                <div style={{ 
                    width: '100%', 
                    height: '400px', 
                    backgroundColor: '#000000a6',
                    
                    // backgroundAttachment: 'fixed',
                }}>
                    <div style={{ width: '90%', height: '400px', justifySelf: 'center' }}>
                        <div style={{ 
                            width: '100%', 
                            height: '300px', 
                            displayalignItems: 'center', 
                            position: 'relative', 
                            borderRadius: '10px', 
                            // backgroundColor: '#5c5c5cc7',
                            backgroundImage: 'url(https://cdn.fstoppers.com/styles/article_med/s3/media/2020/12/21/sized_nh20201031-081155.jpg)',
                            backgroundPosition: 'center',
                            backgroundCepeat: 'no-repeat',
                            backgroundSize: 'cover',
                        }}>
                            <Avatar sizes='large' sx={{ width: '200px', height: '200px', border: '5px solid lightgray', left: '50px', bottom: '-80px', position: 'absolute' }} />   
                        </div>
                        <Typography color='white' variant='h4' sx={{ margin: '17px', height: 'fit-content', width: 'fit-content', left: '240px', position: 'relative' }}>
                            {currentUser?currentUser.nick_name: 'Jestem jaki Jestem'}
                        </Typography>
                    </div>      
                </div>
                <Box sx={{ flexGrow: 1, width:'90%', mt:1 }}>
                    <Grid container spacing={3} alignItems='start' justifyContent='center' justifyItems='center'>
                        <Grid size={{xs: 12, md: 8, lg: 8, xl: 6}} justifyItems='center' sx={{ maxWidth: '500px', maxHeight: '660px'}}>
                            <Item ><AvatarChat /></Item>
                        </Grid>
                        <Grid 
                        container
                        direction="row"
                        sx={{
                        //   justifyContent: "space-between",
                        //   alignItems: "baseline",
                        maxHeight: '660px',
                        overflow: 'auto'
                        }}
                        columnSpacing={2} size={{ sm:12, xl:'grow'}}>
                            <Item><RelationsInfo content={currentUser && currentUser.data?currentUser.data.user_info:null}/></Item>
                            <Item><Box >
                                        <Typography 
                                        color='white'
                                        component="h2"
                                        variant="subtitle3"
                                        sx={{ 
                                            placeSelf: 'start',
                                            fontWeight: '600', 
                                            padding: '5px',
                                            
                                            textShadow: '2px 2px 6px black' }}>
                                            Posty
                                        </Typography>
                                        <Typography
                                            color='white'
                                            component="h3"
                                            sx={{ 
                                                fontWeight: '500',
                                                textShadow:'1px 1px 3px black' }}>
                                                Brak postów
                                        </Typography>
                                    </Box></Item>
                            <Item> <Post content={currentUser && currentUser.data?currentUser.data.prompt:null} /> </Item>
                            <Item> <Post /> </Item>
                            <Item> <Post /> </Item>
                            <Item> <Post /> </Item>
                            <Item> <Post /> </Item>
                        </Grid>
                        
                    </Grid>
                </Box>
            </div>
    );
}   